import { render, staticRenderFns } from "./Type.vue?vue&type=template&id=930fdb34&scoped=true&"
import script from "./Type.vue?vue&type=script&lang=ts&"
export * from "./Type.vue?vue&type=script&lang=ts&"
import style0 from "./Type.vue?vue&type=style&index=0&id=930fdb34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930fdb34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
